import useNetworkEnv from '@hooks/useNetworkEnv';
import React, { useCallback } from 'react';
import MobileMenu from './MobileMenu';

const NetworkEnvMobileMenu = ({
  onMenuItemClick,
  options,
}: {
  onMenuItemClick: () => void;
  options: Array<{ label: string; value: boolean; disabled?: boolean }>;
}) => {
  const [, setIsTestnet] = useNetworkEnv();

  const handleItemClick = useCallback(
    (value) => () => {
      setIsTestnet(value);
      onMenuItemClick();
    },
    [onMenuItemClick, setIsTestnet]
  );

  return (
    <MobileMenu.Container>
      {options.map(({ label, value, disabled }) => (
        <MobileMenu.Item
          key={label}
          onClick={handleItemClick(value)}
          disabled={disabled}
        >
          {label}
        </MobileMenu.Item>
      ))}
    </MobileMenu.Container>
  );
};

export default NetworkEnvMobileMenu;
